<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm
                  ref="resetPasswordForm"
                  @submit.prevent="onSubmitResetPasswordForm"
                >
                  <h1>Reset Password</h1>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    name="password"
                    required
                    v-model="formData.password"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CInput
                    placeholder="Confirm Password"
                    type="password"
                    autocomplete="curent-password"
                    name="confirm-password"
                    required
                    v-model="formData.confirmPassword"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CRow v-if="error">
                    <CCol col="12">
                      <p v-if="error" class="text-danger">{{ error }}</p>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton
                        type="submit"
                        color="primary"
                        class="px-4"
                        :disabled="loading"
                        >Reset</CButton
                      >
                    </CCol>
                  </CRow>
                  <CRow v-if="success">
                    <CCol col="12">
                      <div class="mt-1 mb-1 text-success" v-if="success">
                        {{ success }}
                      </div>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody
                class="h-100 d-flex align-items-center justify-content-center"
              >
                <!-- <img src="images/logo-light.svg" alt=""> -->
                <img
                  src="https://evbids.blob.core.windows.net/assets/images/tesla_logo.png"
                  class="c-sidebar-brand-full"
                  height="45"
                  @click="toHomePage"
                />
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import VErrorResponce from "@/components/VErrorResponce";
import { authStore, createAuthStoreMixin } from "@/mixins/authStoreMixin";
import ModalType from "@/utils/dictionaries/modalType";
export default {
  name: "reset-password",

  mixins: [createAuthStoreMixin()],

  components: {},

  computed: {
    loggedIn() {
      return this[authStore.getterTypes.GETTER_IS_AUTHENTICATED];
    }
  },

  data: () => ({
    loading: false,
    error: null,
    success: null,
    formData: {
      password: null,
      confirmPassword: null,
      token: null
    }
  }),

  methods: {
    toHomePage() {
      this.$router.push("/login");
    },
    async onSubmitResetPasswordForm() {
      //   this.reseting = true
      this.error = null;
      if (!this.formData.password) {
        this.error = "Please enter password";
        return;
      } else if (!this.formData.confirmPassword) {
        this.error = "Please enter confirm password";
        return;
      } else if (this.formData.password !== this.formData.confirmPassword) {
        this.error = "Password did'nt match";
        return;
      } else {
        this.error = null;
      }
      if (!this.error) {
        try {
          await this[authStore.actionTypes.ACTION_RESET_USER_PASSWORD]({
            ...this.formData
          });
          this.success = "Password has been change successfully!.";
          setTimeout(() => {
            this.success = null;
            this.$router.push("/login");
          }, 3000);
        } catch (error) {
          if (
            (error.response && error.response.status === 404) ||
            (error.response && error.response.status === 400)
          ) {
            this.error =
              error.response &&
              error.response.data &&
              error.response.data.description;
          } else {
            this.error = error.response.data;
          }
        } finally {
          // this.reseting = false
        }
      }
    },
    async verifyResetToken() {
      this.error = null;
      debugger;
      this.formData.token = this.$route.params.token;

      try {
        await this[authStore.actionTypes.ACTION_VERIFY_RESET_PASSWORD_TOKEN]({
          token: this.$route.params.token
        });
        this.verification = false;
      } catch (error) {
        if (error.response && error.response.status === 404) {
          debugger;
          console.log("error.response", error.response);
          this.error = error.response.data;
          setTimeout(() => {
            this.error = null;
            // this.toHomePage()
          }, 3000);
          // You can also display a user-friendly message or redirect the user
        } else {
          this.error = error;
        }
      } finally {
        // this.toHomePage()
      }
    },
    openModal() {
      this.$modals.open(ModalType.ForgotPasswordModal);
    },
    async onSubmitForm() {
      this.error = null;
      if (!this.formData.password) {
        this.error = "Please enter password";
        return;
      } else if (!this.formData.confirmPassword) {
        this.error = "Please enter confirm password";
        return;
      } else if (this.formData.password !== this.formData.confirmPassword) {
        this.error = "Password did'nt match";
        return;
      } else {
        this.error = null;
      }
      if (!this.error) {
        try {
          this.loading = true;
          await this[authStore.actionTypes.ACTION_SIGN_IN](this.formData);
          // this.$router.push('/')
          window.location.href = "/";
        } catch (error) {
          this.error = error.response && error.response.data;
        } finally {
          this.loading = false;
        }
      }
    }
  },
  created() {
    this.verifyResetToken();
  },
  mounted() {
    // if (this.loggedIn) {
    //   this.$router.push('/')
    // }
  }
};
</script>
